import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { PrintShell } from '../components/print';
import { usePrintDataQuery } from '../query/export/usePrintDataQuery';

type Search = { token: string };

export const Route = createFileRoute('/print/$bookId/$nodeId')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    token: String(s.token ?? ''),
  }),
  component: PrintPage,
});

function PrintPage() {
  const { bookId, nodeId } = Route.useParams();
  const { token } = Route.useSearch();
  const query = usePrintDataQuery({ bookId, nodeId, token });

  useEffect(() => {
    document.documentElement.setAttribute('data-print-mode', 'true');
    if (query.data) {
      document.documentElement.setAttribute(
        'data-book-state',
        query.data.node.state,
      );
    }
    return () => {
      document.documentElement.removeAttribute('data-print-mode');
      document.documentElement.removeAttribute('data-book-state');
    };
  }, [query.data]);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/print.css';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  if (query.error) {
    return (
      <div
        data-print-error={String(
          (query.error as Error).message ?? query.error,
        )}
      />
    );
  }
  if (!query.data) return null;
  return <PrintShell data={query.data as never} />;
}
